import { tileFromQuadkey } from '@xyo-network/sdk-xyo-js'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'

import { XyoWorldMapStyle } from './lib'

const accessToken = 'pk.eyJ1IjoicGFvbGFiYXRpeiIsImEiOiJjazdsM3pmNmswM293M2VtbnphNjF3YjI5In0.xYVfJRVJSRCJRBTBF6wRUA'

export const getStaticMapUrl = (style = XyoWorldMapStyle.Streets) => {
  const staticMapUrlBase = `https://api.mapbox.com/styles/v1/${style}/static/`
  return `${staticMapUrlBase}0,0,0,0/640x640?access_token=${accessToken}`
}

export const getCroppedMapUrl = (quadkey: Quadkey, style = XyoWorldMapStyle.Streets, size = 32) => {
  const tile = tileFromQuadkey(quadkey.toBase4Hash())

  const url = `https://api.mapbox.com/styles/v1/${style}/tiles/${size <= 256 ? 256 : 512}/${tile[2]}/${tile[0]}/${
    tile[1]
  }?access_token=${accessToken}`
  return url
}
